import { Media } from './media';
import { Publication } from './publication';
import { Config } from '../../config/config';

export class Page extends Publication {

    
    // parent: number;
    parent_page: Page;
    descendant: number[];
    short_title: string;
    video_youtube: string;
    fichier: Media;
    background_color: string;

    constructor() {
        super();
    }

    get linkFichier(): string {

        if( this.fichier !== null && this.fichier !== undefined && this.fichier.url !== null && this.fichier.url !== undefined)
        return  Config.urlserveur + this.fichier.url;
        else
        return null;
    }

    get idparent(): number {

        if( this.parent_page !== null && this.parent_page !== undefined)
        return  this.parent_page.id;
        else
        return null;
    }

    get titreparent(): string {

        if( this.parent_page !== null && this.parent_page !== undefined)
        return  this.parent_page.short_title;
        else
        return null;
    }

   

}
